export const ColorsConstants = {
  primaryBackgroundColor: "#08245C",
  secondaryBackgroundColor: "#1B76D1",
  primaryBlue60: "#F0F5FF",
  primaryBlue70: "#C9D7F5",
  primaryBlue80: "#93AFE8",
  primaryBlue90: "#4B7ACF",
  primaryBlue100: "#08245C",
  primaryPurple60: "#EAF4FF",
  primaryPurple70: "#C6E1FA",
  primaryPurple80: "#8CC3F0",
  primaryPurple90: "#4FA0E4",
  primaryPurple100: "#1B76D1",
  primaryPurple110: "#1976D2",
  primaryGray10: "#E0E0E0",
  primaryGray20: "#C7C7C7",
  primaryGray30: "#AEAEAE",
  primaryGray40: "#959595",
  primaryGray50: "#777677",
  primaryGray60: "#5A5A5A",
  primaryGray70: "#464646",
  primaryGray80: "#353535",
  primaryGray90: "#121212",
  primaryGray100: "#000000",
  secondaryGray:"#E5E7EB",
  inputFieldGrey:"#D1D5DC",
  error: "#b50000",
  success: "#1daa61",
  successText: "#115e36",
  primaryWhite:"#FFFFFF"
};

export const borderColors = {
  cardBorderPrimaryGrayColor: "#E1E8F2",
};

export const dashboardCardBgColor = "#F0F5FF";
export const dashboardCardGreenTextColor = "#008026";
export const grayFontColor = "#61748C";
export const grayPrimaryFontColor="#353535"


export const formConstants = {
  greenButton: "#1daa61"
}

export const inputColor = "#000000DE"
export const searchBarWidth = "300px";
